export const ALL_PERSONA_AUDIENCE = `
    query($filter:AbbvieProPersonaFilter, $first:Int, $last:Int, $after:Cursor, $before:Cursor){
  allAbbvieProPersonas(filter:$filter, orderBy:CREATED_AT_DESC, first:$first, last:$last, after:$after, before:$before){
    nodes{
      id
      personaName
      appName
      country
      personaType
      audienceSpecialty{
        personaKey
        personaText
        audienceType
      }
      email
      createdAt
    }
    totalCount
    pageInfo{
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
`;

export const CREATE_PERSONA = `mutation($abbvieProPersona: AbbvieProPersonaInput!){
  createAbbvieProPersona(input: {
    abbvieProPersona: $abbvieProPersona
  })
  {
    abbvieProPersona{
      id
    }
  }
}`;

export const DELETE_PERSONA = `mutation($id: UUID!){
  deleteAbbvieProPersonaById(input:{
    id:$id
  })
  {
    abbvieProPersona{
      id
    }
  }
}`;

export const UPDATE_PERSONA = `mutation($id: UUID!, $abbvieProPersona: AbbvieProPersonaPatch!){
  updateAbbvieProPersonaById(input:{
    id:$id,
    abbvieProPersonaPatch:$abbvieProPersona
  })
  {
    abbvieProPersona{
      id
    }
  }
}`;
